import React from 'react'

const Minus = props => (
  <svg width='1em' height='1em' viewBox='-1 -1 15 15' {...props}>
    <path d='M14.167 6.833H.833c-.4 0-.666.267-.666.667s.266.667.666.667h13.334c.4 0 .666-.267.666-.667s-.266-.667-.666-.667z' />
  </svg>
)

export default Minus
